"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _preact = _interopRequireWildcard(require("preact"));

var _function = require("../../utils/function.utils");

var _html = require("../../utils/html.utils");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var HeadMenu = /*#__PURE__*/function (_Component) {
  _inherits(HeadMenu, _Component);

  var _super = _createSuper(HeadMenu);

  function HeadMenu() {
    var _this;

    _classCallCheck(this, HeadMenu);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      open: false
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      return document.addEventListener('mousedown', _this._handleClick);
    });

    _defineProperty(_assertThisInitialized(_this), "componentWillUnMount", function () {
      return document.removeEventListener('mousedown', _this._handleClick);
    });

    _defineProperty(_assertThisInitialized(_this), "open", function () {
      return _this.setState({
        open: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "toggleOpen", function () {
      return _this.setState({
        open: !_this.state.open
      });
    });

    _defineProperty(_assertThisInitialized(_this), "close", function () {
      return _this.setState({
        open: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "_handleClick", function (event) {
      // Get the right target also in shadow DOM!!
      var target = event.composedPath && event.composedPath()[0] || event.path && event.path[0] || event.target; // event.target doesn't work in the Shadow Dom

      var targetClass = target.className || ''; // When clicking on SVG targetClass is not a string

      var forceClose = !targetClass.indexOf || targetClass.indexOf('js-mtn-close-headmenu') !== -1;
      var href = forceClose && (target.getAttribute('href') || target.parentNode.getAttribute('href'));
      var isClickScrollbar = (0, _html.isClickOnScrollbar)(event, document);

      if (!isClickScrollbar && _this.containerRef && (forceClose || !_this.containerRef.contains(target))) {
        _this.close();

        _this.props.onClose && _this.props.onClose();
      }

      if (_this.containerRef && forceClose && href) {
        (0, _function.globalClickHandler)(event);
        window.location.href = href;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "_onClick", function (e, allow) {
      (0, _function.globalClickHandler)(e);

      if (allow) {
        e.preventDefault();
        e.stopPropagation();
        _this.props.onOpen ? _this.props.onOpen() : _this.toggleOpen();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "_onClickFull", function (e) {
      return _this._onClick(e, !_this.props.onlyIconClick);
    });

    _defineProperty(_assertThisInitialized(_this), "_onClickIcon", function (e) {
      return _this._onClick(e, _this.props.onlyIconClick);
    });

    _defineProperty(_assertThisInitialized(_this), "_setRef", function (ref) {
      return _this.containerRef = ref;
    });

    return _this;
  }

  _createClass(HeadMenu, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          label = _this$props.label,
          content = _this$props.content,
          icon = _this$props.icon,
          isDropdown = _this$props.isDropdown,
          className = _this$props.className,
          greyIcon = _this$props.greyIcon,
          fixedSize = _this$props.fixedSize,
          link = _this$props.link,
          labelIcon = _this$props.labelIcon,
          forceLabelShow = _this$props.forceLabelShow,
          forceOpen = _this$props.forceOpen,
          id = _this$props.id,
          alt = _this$props.alt;
      var open = this.state.open;
      return (0, _preact.h)("div", {
        id: id,
        ref: this._setRef,
        className: "mtn-m-headmenu ".concat(forceLabelShow ? 'mtn-m-headmenu--show' : '', " ").concat(className ? className : '', " ").concat(open || forceOpen ? 'mtn-m-headmenu--open' : '')
      }, (0, _preact.h)("a", {
        alt: alt,
        href: link ? link : 'javascript:void(0);',
        className: "mtn-m-headmenu__button ".concat(isDropdown ? 'mtn-m-headmenu__button--dropdown' : '', " ").concat(icon ? 'mtn-m-headmenu__button--icon' : ''),
        onClick: link ? null : this._onClickFull
      }, icon ? (0, _preact.h)("span", {
        onClick: link ? null : this._onClickIcon,
        className: "mtn-m-headmenu__imagebox ".concat(greyIcon ? 'mtn-m-headmenu__imagebox--grey' : '', " ").concat(fixedSize ? 'mtn-m-headmenu__imagebox--fixed-image' : '')
      }, (0, _preact.h)("img", {
        className: "mtn-m-headmenu__image",
        alt: "",
        src: icon
      })) : null, (0, _preact.h)("span", {
        className: "mtn-m-headmenu__button-label ".concat(labelIcon ? 'mtn-m-headmenu__button-label--with-icon' : '')
      }, label, labelIcon ? (0, _preact.h)("fa", {
        className: "mtn-m-headmenu__button-icon fa fa-".concat(labelIcon)
      }) : null)), open || forceOpen ? (0, _preact.h)("div", {
        id: id ? "".concat(id, "-content") : null,
        className: "mtn-m-headmenu__content"
      }, content) : null);
    }
  }]);

  return HeadMenu;
}(_preact.Component);

HeadMenu.defaultProps = {
  greyIcon: false
};
var _default = HeadMenu;
exports["default"] = _default;